import $ from 'jquery';
import throttle from 'throttle-debounce/throttle';

const config = {
  headerBarVerticalThreshold: 200, // height(.header__top) - height(.header__bar)
};

const state = {
  menuIsOpen: false,
};

function toggleMenu(newState = undefined) {
  if (newState === undefined) {
    state.menuIsOpen = !state.menuIsOpen;
  } else {
    state.menuIsOpen = !!newState;
  }
  $('.toggle-menu')
    .attr('aria-expanded', state.menuIsOpen)
    .toggleClass('toggle-menu--open', state.menuIsOpen);

  $('.header__menu')
    .attr('aria-expanded', state.menuIsOpen)
    .toggleClass('header__menu--open', state.menuIsOpen);

  $('.menu a').attr('tabindex', state.menuIsOpen ? '0' : '-1');
  // $('#sidebar')
  //   .attr('aria-expanded', newState)
  //   .toggleClass('header__sidebar--visible', newState);
  // $('.header__bar-burger')
  //   .attr('aria-expanded', newState)
  //   .toggleClass('header__bar-burger--expanded', newState);
  // $('.header__sidebar-close').attr('aria-expanded', newState);
}

/**
 * Add --fixed to header__bar when below a certain threshold
 */
// const headerBar = $('.header__bar');
// let isFarEnoughDown = document.scrollTop > config.headerBarVerticalThreshold;
function handleScroll() {
  // const newFarEnoughDown = ($(document).scrollTop() > config.headerBarVerticalThreshold);
  // if (isFarEnoughDown !== newFarEnoughDown) {
  //   headerBar.toggleClass('header__bar--visible', newFarEnoughDown);
  //   if (!newFarEnoughDown) {
  //     toggleMenu(false);
  //   }
  // }
  // isFarEnoughDown = newFarEnoughDown
}

function initializeHeadersAndMenus() {
  $('.toggle-menu').on('click', () => {
    toggleMenu();
  });

  // $('.header__sidebar-close').on('click', () => {
  //   toggleMenu(false);
  //   return false;
  // });

  // $(window).on('scroll', throttle(25, handleScroll));

  // // Make sure a resize doesn't sneak the scroll position over the threshold
  // $(window).on('resize', throttle(100, handleScroll));

  // // Initialize on load
  // handleScroll();
}

export default initializeHeadersAndMenus;

/**
 * Menu from onsunde
 */
/*
import classie from 'classie'

const loadMenu = () => {

  var triggerBtn = document.getElementById('toggle_menu');
  var overlay = document.querySelector('div.header__narrow');

  var transEndEventNames = {
      'WebkitTransition': 'webkitTransitionEnd',
      'MozTransition': 'transitionend',
      'OTransition': 'oTransitionEnd',
      'msTransition': 'MSTransitionEnd',
      'transition': 'transitionend'
    };

  //var transEndEventName = transEndEventNames[ Modernizr.prefixed('transition') ];
  var transEndEventName = transEndEventNames[ 'transition' ];

  var support = { transitions: Modernizr.csstransitions };

  function toggleOverlay() {
    if (classie.has(overlay, 'open')) {
      classie.remove(overlay, 'open');
      classie.remove(triggerBtn, 'open');
      classie.add(overlay, 'closing');
      var onEndTransitionFn = function(ev) {
        if (support.transitions) {
          this.removeEventListener(transEndEventName, onEndTransitionFn);
        }
        classie.remove(overlay, 'closing');
      };
      if (support.transitions) {
        overlay.addEventListener(transEndEventName, onEndTransitionFn);
      } else {
        onEndTransitionFn();
      }
    } else if (!classie.has(overlay, 'closing')) {
      classie.add(overlay, 'open');
      classie.add(triggerBtn, 'open');
    }
  }

  triggerBtn.addEventListener('click', toggleOverlay);
}

export default loadMenu

  //   if (classie.has(overlay, 'open')) {

  //     classie.remove(overlay, 'open');
  //     classie.remove(triggerBtn, 'open');
  //     var onEndTransitionFn = function(ev) {
  //       if (support.transitions) {
  //         if (ev.propertyName !== 'visibility') { return; }
  //         this.removeEventListener(transEndEventName, onEndTransitionFn);
  //       }
  //       classie.add(overlay, 'closed');
  //     };
  //     if (support.transitions) {
  //       overlay.addEventListener(transEndEventName, onEndTransitionFn);
  //     } else {
  //       onEndTransitionFn();
  //     }
  //   } else {
  //     classie.add(overlay, 'open');
  //     classie.add(triggerBtn, 'open');
  //     classie.remove(overlay, 'closed');
  //   }
  // }

*/
